import serve from '@/utils/request.js'
import Setting from '@/settings.js'
var { interFaceDomain } = Setting
// const dicBaseUrl = dictDomain + "/base/admin/dic/list"
// const adverDomain = dictDomain + "/base/admin/param/detail/byParamKey"
// interFaceDomain = 'https://www.fastmock.site/mock/9f5b07a35e6126897a07aba04649dfec/front'
//获取流量主列表
export function siteList (data) {
  return serve.post(interFaceDomain + "/jdmob/traffic/searchTrafficUser", data)
}
//修改流量主状态
export function changeStatus (param) {
  return serve.get(interFaceDomain + "/jdmob/traffic/updateTrafficStatus", param)
}
// 重置密码
export function resetPwd (param) {
  return serve.get(interFaceDomain + "/jdmob/user/resetPwd", param)
}
//创建流量主
export function createSiter (data) {
  return serve.post(interFaceDomain + "/jdmob/traffic/createTraffic", data)
}
// 流量主详情
export function siterDetail (param) {
  return serve.get(interFaceDomain + "/jdmob/traffic/detailById", param)
}
//编辑流量主
export function editSiter (data) {
  return serve.post(interFaceDomain + "/jdmob/traffic/updateTraffic", data)
}
// 获取所有媒介
export function allMeijie (param) {
  return serve.get(interFaceDomain + "/jdmob/adminUser/selectMediaAdminUserList", param)
}
// 获取流量主关联数据包详情
export function packetNum (param) {
  return serve.get(interFaceDomain + "/jdmob/traffic/getPackagesInfo", param)
}
// 获取流量主关联产品详情
export function productNum (param) {
  return serve.get(interFaceDomain + '/jdmob/traffic/getProductsInfo', param)
}
// 审核流量主
export function checkSiter (data) {
  return serve.post(interFaceDomain + "/jdmob/user/review", data)
}
//创建广告主
export function addBasicInfo (data) {
  return serve.post(interFaceDomain + "/jdmob/traffic/createTraffic", data)
}
// 创建主体和收件信息
export function addAdver (param1, param2) {
  return serve.all([
    serve.post(interFaceDomain + "/jdmob/traffic/trafficIncreaseSubject", param1),
    serve.post(interFaceDomain + "/jdmob/traffic/increaseSubjectReceivingInformation", param2)
  ])
}
// 获取流量主所有信息
export function getAllInfo (param) {
  return serve.get(interFaceDomain + '/front/traffic/selectTrafficBoyInfo', param)
}

// 更新基本信息
export function updateBasicInfo (data) {
  return serve.post(interFaceDomain + "/front/traffic/UpdateTrafficBasicInfo", data)
}

// 添加主体信息
export function addSubjectInfo (data) {
  return serve.post(interFaceDomain + "/front/traffic/trafficIncreaseSubject", data)
}
// 更新主体信息
export function updateSubjectInfo (data) {
  return serve.post(interFaceDomain + "/front/traffic/trafficUpdateSubject", data)
}
// 新增收件信息
export function addReceiveInfo (data) {
  return serve.post(interFaceDomain + "/front/traffic/increaseSubjectReceivingInformation", data)
}
// 更新收件信息
export function updateReceiveInfo (data) {
  return serve.post(interFaceDomain + "/front/traffic/updateSubjectReceivingInformation", data)
}
// 添加授信额度
export function creditLine (data) {
  return serve.post(interFaceDomain + "/jdmob/traffic/updateCreditLineByid", data)
}
// 获取授信额度
export function getCreditLine (param) {
  return serve.get(interFaceDomain + "/front/traffic/getCreditLineById", param)
}
//获取邮箱验证码
// export function getEmailNumber (params) {
//   return serve.get(interFaceDomain + "/front/user/sendEmailCode", params)
// }
export function getEmailNumber (params) {
  return serve({
    url: interFaceDomain + '/front/user/sendEmailCode',
    method: 'get',
    params
  })
}
//修改流量主密码
export function updatePassword (data) {
  return serve.post(interFaceDomain + "/front/user/changePassword", data)
}
//用户退出
export function logOut (param) {
  return serve.get(interFaceDomain + "/front/user/loginOut", param)
}
